module.exports = __webpack_public_path__ + "static/media/Loyalty_Mail_Icon@3x.4ddfc1da.png";